module.exports = __webpack_public_path__ + "img/cart-delete-bg.a9da86f5.png";